import request from './request'

export const submitPrint = item => {
    return request({
        url: '/print/submitPrint',
        method: 'POST',
        data: {
            bookId: item.id,
            name: item.name
        }
    })
}
export const getPrintList = bookId => {
    return request({
        url: '/print/getPrintList',
        method: 'POST',
        data: { bookId }
    })
}
export const removePrint = id => {
    return request({
        url: '/print/removePrint',
        method: 'POST',
        data: { id }
    })
}
